<template>
    <div>
        <v-overlay :value="showOverlay" class="text-center">
            <v-progress-circular indeterminate size="64"></v-progress-circular>

            <p class="text-caption text-light mt-10">Importing in Progress . . .</p>
        </v-overlay>

        <v-card elevation="0" height="310" class="pa-4 text-center">

            <v-card-text v-if="!uploading" class="pa-2">
                <p class="text-caption text-light ma-0">Start import {{ this.termlabel }} - individual who provide services
                    or products
                    like, instructors, coach, doctor etc.
                </p>

                <v-btn class="ma-2" small plain color="indigo" @click="downloadTeacherTemplate">
                    <v-icon>mdi-download</v-icon>
                    Download excel template file
                </v-btn>

                <v-file-input :label="'Import ' + this.termlabel" v-model="importFileTeachers" @change="parseTeachersFile"
                    accept=".xlsx,.xls,.csv"></v-file-input>

                <v-btn v-if="teachersParsed" class="ma-2" small plain color="indigo" @click="toImportTeachersDialog = true">
                    <v-icon>mdi-magnify-plus-outline</v-icon>
                    Preview to Import ({{ this.termlabel }} )
                </v-btn>

                <v-btn v-if="teachersParsed" color="primary" block rounded x-large @click="startImporting">
                    Start Import
                </v-btn>
            </v-card-text>


            <v-card-action>
                <v-btn v-if="uploading" class="ma-2" small plain color="indigo" @click="importStatusDialog = true">
                    <v-icon>mdi-chart-donut</v-icon>
                    Import status Report
                </v-btn>
            </v-card-action>

        </v-card>

        <v-row justify="center">
            <v-dialog v-model="toImportTeachersDialog" persistent max-width="600px">
                <v-card>
                    <v-card-title>
                        <span class="text-h5">Import {{ this.termlabel }} </span>
                    </v-card-title>
                    <v-card-text>

                        <v-data-table :headers="teachersTableHeaders" :items="teachersTableItems"
                            class="elevation-1"></v-data-table>

                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" text @click="toImportTeachersDialog = false">
                            Close
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>

        <v-row justify="center">
            <v-dialog v-model="importStatusDialog" persistent max-width="600px">
                <v-card>
                    <v-card-title>
                        <span class="text-h5">Import Status Report -</span>
                    </v-card-title>
                    <v-card-text>

                        <div v-if="uploading">
                            <v-row>
                                <v-col>
                                    <p>{{ this.termlabel }}s Uploaded: {{ uploadedCount }}</p>
                                </v-col>
                                <v-col>
                                    <p>Failed Uploads: {{ failedTeachers.length }}</p>
                                </v-col>
                                <v-col>
                                    <p>Items with issue/s: {{ itemsWithIssueCount }}</p>
                                </v-col>

                            </v-row>

                            <v-card v-if="failedTeachers.length">
                                <v-simple-table fixed-header height="300px">
                                    <template v-slot:default>
                                        <thead>
                                            <tr>
                                                <th class="text-left">
                                                    {{ this.termlabel }}
                                                </th>
                                                <th class="text-left">
                                                    Reasons
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(failure, index) in failedTeachers" :key="index">
                                                <td>{{ failure.teacher.firstName }} {{ failure.teacher.lastName }} ({{
                                                    failure.teacher.email
                                                }}) </td>
                                                <td>{{ failure.reason }}</td>
                                            </tr>
                                        </tbody>
                                    </template>
                                </v-simple-table>
                            </v-card>
                        </div>


                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" text @click="importStatusDialog = false">
                            Close
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>

    </div>
</template>


<script>
import { mapActions, mapGetters } from "vuex";
import Papa from 'papaparse';

import { mask } from "vue-the-mask";
import { rules } from "@/store/util/rules.js";
import randomColor from "randomcolor";
import "vue-tel-input/dist/vue-tel-input.css";


export default {
    name: 'TeacherImport',
    props: {
        centers: { type: Array, required: true },
        termlabel: { type: String, required: true }
    },
    data() {
        return {
            rules,
            toImportTeachersDialog: false,
            importStatusDialog: false,
            importFileTeachers: null,
            teachersContent: [],
            teachersParsed: false,
            teachersTableHeaders: [],
            teachersTableItems: [],
            uploading: false,
            uploadedCount: 0,
            itemsWithIssueCount: 0,
            failedTeachers: [],
            uploadedPercentage: null,
            failedPercentage: null,
            showOverlay: false
        };
    },
    directives: { mask },
    computed: {
        ...mapGetters('navigation', ["isAppLoading", "globalCenter"]),
    },
    mounted() {
        if (this.centers && this.centers.length == 1) {
            this.center = this.centers[0].id;
        } else if (this.globalCenter && this.globalCenter.id) {
            this.center = this.globalCenter.id;
        }
    },
    methods: {
        ...mapActions(["addErrorMessage"]),

        parseTeachersFile() {
            Papa.parse(this.importFileTeachers, {
                header: true,
                skipEmptyLines: true,
                complete: function (results) {
                    this.teachersContent = results;
                    this.teachersParsed = true;

                    this.teachersContent.meta.fields.forEach((item) => {
                        const _header = { text: item, value: item }
                        this.teachersTableHeaders.push(_header);
                    })

                    this.teachersContent.data.forEach((item) => {
                        const _item = {
                            center: item.center,
                            firstname: item.firstname,
                            lastname: item.lastname,
                            email: item.email,
                            phone: item.phone,
                            about: item.about,
                        }
                        this.teachersTableItems.push(_item);
                    })

                }.bind(this)
            });
        },
        removeDuplicatesAndEmptyRows(list) {
            const seen = new Set();

            return list.filter(item => {
                const emailKey = item.email || '';
                const phoneKey = item.phone || '';

                // Remove row if all keys are empty
                if (!emailKey.trim() && !phoneKey.trim()) {
                    return false;
                }

                // Check if any of the keys have been seen before
                if (seen.has(emailKey) || seen.has(phoneKey)) {
                    return false;
                }

                // If not, add the keys to the set and include the item in the result
                seen.add(emailKey);
                seen.add(phoneKey);
                return true;
            });
        },
        startImporting() {
            this.uploading = true;
            this.showOverlay = true;

            const filteredList = this.removeDuplicatesAndEmptyRows(this.teachersTableItems);
            const chunkSize = 10;

            // Split the filtered list into chunks of 10
            for (let i = 0; i < filteredList.length; i += chunkSize) {
                const chunk = filteredList.slice(i, i + chunkSize);

                // Iterate through each chunk and send requests
                chunk.forEach((item) => {
                    const teacher = {
                        centerId: item.center,
                        firstName: item.firstname,
                        lastName: item.lastname,
                        email: item.email,
                        phone: item.phone,
                        // phoneCountryCode: item.phoneInput.countryCode,
                        about: item.about,
                        color: randomColor.randomColor(),
                    };

                    this.addNewTeacher(teacher);
                });

                this.showOverlay = false;
            }
            this.itemsWithIssueCount = this.teachersTableItems.length - filteredList.length;
            const a = this.failedTeachers.length / 100;
            this.failedPercentage = a * filteredList.length;


        },
        async addNewTeacher(newTeacher) {
            const savedTeacher = await this.importTeacher(newTeacher);
            if (savedTeacher) {
                this.uploadedCount++;
            }
        },
        async importTeacher(teacher) {
            return await this.$axios
                .post("/teacher/update", teacher)
                .then((resp) => {
                    const savedTeacher =
                        resp.data && resp.data.data ? resp.data.data : null;
                    return savedTeacher;
                })
                .catch((error) => {
                    this.failedTeachers.push({ teacher, reason: error.data.message });
                });
        },
        downloadTeacherTemplate() {
            const url = '/downloads/teachers.csv';
            window.location.href = url;
        }
    },
};
</script>
